import React, { useState } from "react";
import { Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";
import { EditIcon } from "./constant";
import { PrintIcon } from "./constant";
import { FiBell } from "react-icons/fi";
import ModifyPayment from "./modifyPayment/ModifyPayment";
import { checkPaymentModeApprovalStatus } from "./utils";
import { printReceipt } from "../constants";
import SendNotification from "../SendNotification";
import ALoader from "views/pages/manage/common/a-loader";

const ReceiptAction = ({
  actionDisable,
  rowList = [],
  totalPaidAmount = 0,
  contextValue,
  isListing = false,
  studentBasicDetails,
  opportunityOwnerId ,
  applicationId
}) => {
  const noActionEnableColor = actionDisable?.noActionEnable
    ? "#B7B7B7"
    : "#0F0F0F";
  const modifyPaymentColor =
    actionDisable?.modifyPayment || actionDisable?.noActionEnable || !applicationId || !applicationId?.trim()
      ? "#B7B7B7"
      : "#0F0F0F";

  const [isModifyOpen, setModifyOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [isGeneratingReceipt, setIsGeneratingReceipt] = useState(false);

  const modifyHandler = () => {
    checkPaymentModeApprovalStatus(
      studentBasicDetails?.receiptId,
      setModifyOpen
    );
  };
  const printReceiptHandler = async () => {
    const { businessArea, receiptId } = studentBasicDetails;

    const data = { receipts: [{ businessArea, receiptId }] };
    setLoader(true);
    await printReceipt(data);
    setLoader(false);
  };
  const notificationHandler = () => {
    setIsNotifOpen(true);
  };

  return (
    <>
      {!isListing && (
        <Card style={{ width: "35%", height: "256px", marginLeft: "40px" }}>
          <CardBody>
            <div className="dark-text label-color">Receipt Actions</div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={!actionDisable?.noActionEnable && printReceiptHandler}
            >
              <PrintIcon color={noActionEnableColor} />
              <span style={{ color: `${noActionEnableColor}` }}>
                Print Receipt
              </span>
            </div>

            <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={() => {
                !(
                  actionDisable?.modifyPayment || actionDisable?.noActionEnable || !applicationId || !applicationId?.trim()
                ) && modifyHandler();
              }}
            >
              <EditIcon color={modifyPaymentColor} />
              <span style={{ color: `${modifyPaymentColor}` }}>
                Modify payment method
              </span>
            </div>

            <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={!actionDisable?.noActionEnable && notificationHandler}
            >
              <FiBell
                style={{
                  width: "22px",
                  height: "26px",
                  color: `${noActionEnableColor}`,
                }}
              />
              <span style={{ color: `${noActionEnableColor}` }}>
                Send Notification
              </span>
            </div>
          </CardBody>
        </Card>
      )}
      <ModifyPayment
        contextValue={contextValue}
        isOpen={isModifyOpen}
        setIsOpen={setModifyOpen}
        rowList={rowList}
        totalPaidAmount={totalPaidAmount}
      />
      {isNotifOpen && (
        <SendNotification
          open={isNotifOpen}
          receiptDetails={{...studentBasicDetails,opportunityOwnerId}}
          handleCloseDialog={() => {
            setIsNotifOpen(false);
          }}
          setIsGeneratingReceipt={setIsGeneratingReceipt}
        />
      )}
      {(loader || isGeneratingReceipt) && <ALoader />}
    </>
  );
};

export default ReceiptAction;
